module.exports = __webpack_public_path__ + "img/43.1d75729e.jpg";